import React from "react";
import CommonLayout from "../../layouts/master/index";
// import List from "./List";
import List2 from "./List2";



export default function CreditsLog() {

  const titles = [
    { name: 'Credits History', path: '/customers' },
  ];

  return (
    <>
      <CommonLayout titles={titles}>    
        <div>
          {/* this is old style */}
          {/* <List/> */}

          {/* this is new style */}
          <List2/>
      
        </div>
      </CommonLayout>
    </>
  );
}
